import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY



export const getZonesOption = async (setZonesOptions) => {
    try {
        const res = await api.get(`${urlApi}/direccion/getZonesOption`);
        setZonesOptions(res.data);
    } catch (error) {
        console.error('API call error in getUsersInCharge:', error);
       
    }
};

export const getUsersInCharge = async (setUsersInCharge) => {
    try {
        const res = await api.get(`${urlApi}/direccion/getUsersInCharge`);
        // Asumiendo que res.data ya es el objeto { "A": {...}, "B": {...} }
        setUsersInCharge(res.data);
    } catch (error) {
        console.error('API call error in getUsersInCharge:', error);
       
    }
};
export const getOptionsLeaders = async (setState) => {
    try {
        const res = await api.get(`${urlApi}/direccion/getOptionsLeaders`);
        setState(res.data);
    } catch (error) {
        console.error('API call error in getUsersInCharge:', error);
       
    }
};
export const getOptionsExecutives = async (setState) => {
    try {
        const res = await api.get(`${urlApi}/direccion/getOptionsExecutives`);
        setState(res.data);
    } catch (error) {
        console.error('API call error in getUsersInCharge:', error);
       
    }
};
export const getClientsZones = async (setState) => {
    try {
        const res = await api.get(`${urlApi}/direccion/getClientsZones`);
        setState(res.data);
    } catch (error) {
        console.error('API call error in getUsersInCharge:', error);
       
    }
};
export const getUnitsZones = async (setState) => {
    try {
        const res = await api.get(`${urlApi}/direccion/getUnitsZones`);
        setState(res.data);
    } catch (error) {
        console.error('API call error in getUsersInCharge:', error);
       
    }
};
export const updateZoneLeader = async (params) => {
    try {
        const res = await api.put(`${urlApi}/direccion/updateLeater`,params);
    } catch (error) {
        console.error('API call error in getUsersInCharge:', error);
       
    }
};
export const updateZoneExecutive = async (params) => {
    try {
        const res = await api.put(`${urlApi}/direccion/updateZoneExecutive`,params);
    } catch (error) {
        console.error('API call error in getUsersInCharge:', error);
       
    }
};
export const updateClient = async (params) => {
    try {
        const res = await api.put(`${urlApi}/direccion/updateClient`,params);
    } catch (error) {
        console.error('API call error in getUsersInCharge:', error);
       
    }
};
export const updateUnit = async (params) => {
    try {
        const res = await api.put(`${urlApi}/direccion/updateUnit`,params);
    } catch (error) {
        console.error('API call error in getUsersInCharge:', error);
       
    }
};
export const getPositionUnit = async (id_unit,setPosition) => {
    try {
        const res = await api.get(`${urlApi}/direccion/getUnitPosition?id_unit=${id_unit}`);
        console.log("res",res.data);
        return res.data
        // setPosition(res.data)
    } catch (error) {
        console.error('API call error in getUsersInCharge:', error);
       
    }
};